module.exports = __webpack_public_path__ + "img/programme_icon_shequn@3x.18266a46.png";